import classnames from 'classnames';
import colornames from '../../../lib/colornames';

const getTitleClassName = ({ picker, namespace, hasError }) =>
  classnames(`${namespace}__label`, colornames(picker.label), {
    [colornames(picker.error_message && picker.error_message?.label?.color)]: hasError,
  });

const getBoxTitleClassName = ({ picker, namespace, hasError }) =>
  classnames(
    {
      [`${colornames(picker.error_message && picker.error_message.label.color)}`]: hasError,
    },
    {
      [`${namespace}__box__label--shake`]: hasError,
    },
    {
      [`${namespace}__box__label--with-subtitle`]: picker.selected_subtitle,
    },
    `${namespace}__box__label`,
  );

const getDefaultVariationClassName = ({ picker, namespace, hasError, showSelectedOption, showOuterMessage }) =>
  classnames(
    `${namespace}__selected-label`,
    colornames(hasError ? picker.error_message.selected_option.color : picker.selected_option),
    {
      [colornames(picker.selected_option.color)]: showSelectedOption,
      [colornames(picker.outer_message?.color)]: showOuterMessage,
    },
  );

export { getTitleClassName, getBoxTitleClassName, getDefaultVariationClassName };
